import { render, staticRenderFns } from "./ApplyVoterRegistration.vue?vue&type=template&id=67d5e72c"
import script from "./ApplyVoterRegistration.vue?vue&type=script&lang=js"
export * from "./ApplyVoterRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports